var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},[_c('poll',{attrs:{"questionID":_vm.questionID,"question":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }